import { useCallback } from 'react';
import { LINE_ITEM_FIELDS } from '../utils/lineItemImport.utils';

/**
 * Hook for column matching (simplified - no AI, just rule-based)
 */
export const useAIColumnMatching = () => {
  /**
   * Get available fields for dropdown selection
   */
  const getFieldOptions = useCallback(() => {
    return [
      { value: null, label: '-- Skip --' },
      ...Object.entries(LINE_ITEM_FIELDS).map(([key, def]) => ({
        value: key,
        label: `${def.label}${def.required ? ' *' : ''}`,
      })),
    ];
  }, []);

  return {
    getFieldOptions,
    isMatching: false,
    matchingError: null,
  };
};

export default useAIColumnMatching;
